import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    width: "100%",
    maxWidth: "1440px",
    margin: "0 auto",
    padding: "28px 120px 60px",
    boxSizing: "border-box",
    background: "#FFFFFF",

    [theme.breakpoints.down("sm")]: {
      padding: "20px 20px 40px",
    },

    [theme.breakpoints.down("xs")]: {
      padding: "16px 16px 32px",
    },
  },

  // Header logos
  logoHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "20px",

    paddingBottom: "22px",
    marginBottom: "32px",

    [theme.breakpoints.down("xs")]: {
      paddingBottom: "16px",
      marginBottom: "24px",
    },
  },

  kmLogoLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flex: "0 0 150px",
    width: "150px",
    minWidth: 0,
    textDecoration: "none",

    [theme.breakpoints.down("xs")]: {
      flexBasis: "115px",
      width: "115px",
    },
  },

  kmLogo: {
    display: "block",
    width: "100%",
    maxWidth: "none",
    height: "auto",
    flexShrink: 0,
    objectFit: "contain",
    objectPosition: "left center",
  },

  openPlayLogo: {
    display: "block",
    width: "125px",
    maxWidth: "40%",
    height: "auto",
    flexShrink: 0,
    objectFit: "contain",
    objectPosition: "right center",

    [theme.breakpoints.down("xs")]: {
      width: "100px",
    },
  },

  // Hero
  heroSection: {
    width: "100%",
    textAlign: "center",
    marginBottom: "44px",
  },

  heroHeading: {
    margin: "0 0 22px",
    color: "#F15922",
    fontSize: "38px",
    lineHeight: 1.25,
    fontWeight: 800,
    textAlign: "center",

    [theme.breakpoints.down("sm")]: {
      fontSize: "30px",
      marginBottom: "18px",
    },

    [theme.breakpoints.down("xs")]: {
      fontSize: "18px",
      lineHeight: 1.3,
      marginBottom: "16px",
    },
  },

  heroDescription: {
    width: "100%",
    boxSizing: "border-box",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",

    padding: "20px 28px",

    border: "1px solid #FAD2C4",
    borderRadius: "28px",
    background: "#FFFFFF",
    boxShadow: "0 3px 8px rgba(0, 0, 0, 0.06)",

    [theme.breakpoints.down("sm")]: {
      padding: "18px 20px",
      borderRadius: "22px",
    },

    [theme.breakpoints.down("xs")]: {
      padding: "16px 14px",
      borderRadius: "20px",
      gap: "5px",
    },
  },

  tagline: {
    margin: 0,
    color: "#333333",
    fontSize: "22px",
    lineHeight: 1.5,
    fontWeight: 700,
    textAlign: "center",

    [theme.breakpoints.down("sm")]: {
      fontSize: "19px",
    },

    [theme.breakpoints.down("xs")]: {
      fontSize: "16px",
      lineHeight: 1.5,
    },
  },

  communityStats: {
    margin: 0,
    color: "#F15922",
    fontSize: "22px",
    lineHeight: 1.5,
    fontWeight: 700,
    textAlign: "center",

    [theme.breakpoints.down("sm")]: {
      fontSize: "19px",
    },

    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
      lineHeight: 1.5,
    },
  },
  // City section
  citySection: {
    width: "100%",
  },

  citySelectionCard: {
    width: "100%",
    boxSizing: "border-box",

    padding: "28px",
    border: "1px solid #EAEAEA",
    borderRadius: "24px",
    background: "#FFFFFF",
    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.04)",

    [theme.breakpoints.down("sm")]: {
      padding: "22px",
      borderRadius: "20px",
    },

    [theme.breakpoints.down("xs")]: {
      padding: "18px 14px",
      borderRadius: "18px",
    },
  },

  chooseCityHeading: {
    margin: "0 0 28px",
    color: "#333333",
    fontSize: "25px",
    lineHeight: 1.4,
    fontWeight: 700,

    [theme.breakpoints.down("xs")]: {
      fontSize: "18px",
      marginBottom: "22px",
    },
  },

  // Responsive grid: 5 desktop, 3 tablet, 2 mobile
  cityGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
    columnGap: "20px",
    rowGap: "36px",
    width: "100%",

    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      columnGap: "18px",
      rowGap: "32px",
    },

    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      columnGap: "14px",
      rowGap: "28px",
    },

    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      columnGap: "12px",
      rowGap: "26px",
    },
  },

  cityCard: {
    width: "100%",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0",
    border: "none",
    outline: "none",
    background: "transparent",
    cursor: "pointer",
    fontFamily: "inherit",
    WebkitTapHighlightColor: "transparent",

    "&:focus-visible": {
      outline: "2px solid #F15922",
      outlineOffset: "5px",
      borderRadius: "12px",
    },

    "&:hover $cityImageWrapper": {
      transform: "translateY(-3px)",
    },

    "&:hover $cityName": {
      color: "#F15922",
    },
  },

  cityImageWrapper: {
    position: "relative",
    width: "132px",
    height: "132px",
    maxWidth: "100%",
    margin: "0 auto 16px",
    border: "3px solid #008A45",
    borderRadius: "50%",
    boxSizing: "border-box",
    transition: "transform 0.2s ease",
    overflow: "visible",

    [theme.breakpoints.down("sm")]: {
      width: "118px",
      height: "118px",
    },

    [theme.breakpoints.down("xs")]: {
      width: "min(132px, 100%)",
      height: "auto",
      aspectRatio: "1 / 1",
      marginBottom: "12px",
    },
  },

  cityImage: {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%",
  },

  blankCityImage: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    background: "#FFFFFF",
  },

  whatsappIcon: {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    width: "34px",
    height: "34px",
    objectFit: "contain",
    zIndex: 1,

    [theme.breakpoints.down("xs")]: {
      width: "30px",
      height: "30px",
    },
  },

  cityName: {
    width: "100%",
    color: "#424242",
    fontSize: "17px",
    lineHeight: 1.4,
    fontWeight: 600,
    textAlign: "center",
    overflowWrap: "anywhere",
    transition: "color 0.2s ease",

    [theme.breakpoints.down("sm")]: {
      fontSize: "15px",
    },

    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },
}));

export default useStyles;
